<template>
    <div class="tieIn">
        <div class="tieIn-content">
            <div style="color: #adadad;margin:1rem 0;font-size: 1rem;">
                <div>
                    <div class="zoom-tip">
                        <div class="detail-item">
                            <div class="label">编号</div>
                            <div class="value">{{ form.code }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">起始井号</div>
                            <div class="value">{{ form.pointFrom }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">终止井号</div>
                            <div class="value">{{ form.pointTo }}</div>
                        </div>
                    </div>
                    <div class="zoom-tip">
                        <div class="detail-item">
                            <div class="label">材质</div>
                            <div class="value">{{ form.material }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">管长(m)</div>
                            <div class="value">{{ form.length }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">管径(mm)</div>
                            <div class="value">{{ form.diameter }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <a-tabs v-model="activeTab">
                <a-tab-pane key="1" tab="信息">
                    <form>
                        <div class="tieIn-title1">
                            <div style="display: flex;justify-content: space-between;">
                                <SelectField style="margin: 0.5rem auto;width: 48%;" label="管段类型" id="pipeType"
                                             :modelValue="form.pipeType" :options="pipeTypes" labelWidth="60%"
                                             @update:modelValue="(value) => handleModelValueUpdate('pipeType', value)"
                                />
                                <SelectField style="margin: 0.5rem auto;width: 48%;" label="检测方向" id="detDirection"
                                             :modelValue="form.detDirection" :options="detDirections" labelWidth="60%"
                                             @update:modelValue="(value) => handleModelValueUpdate('detDirection', value)"
                                />
                            </div>
                            <div class="tieIn-title-name">结构性缺陷</div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="结构性缺陷" id="structGrade" placeholder="请选择结构性缺陷" inputDivWidth="79%"
                                             :modelValue="form.structGrade" :options="pipeDefectList" labelWidth="24%"
                                             @update:modelValue="(value) => handleModelValueUpdate('structGrade', value)"
                                />
                            </div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="管段修复" id="structRepair" placeholder="请选择管段修复" inputDivWidth="79%"
                                              :modelValue="form.structRepair" :options="repairIndexList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('structRepair', value)"
                                />
                            </div>
                            <div class="tieIn-title-name">功能性缺陷</div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="功能性缺陷" id="alityGrade" placeholder="请选择功能性缺陷" inputDivWidth="79%"
                                              :modelValue="form.alityGrade" :options="functionDefectList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('alityGrade', value)"
                                />
                            </div>
                            <div style="margin-bottom: 1rem;">
                                <SelectField  label="管段养护" id="alityRepair" placeholder="请选择管段养护" inputDivWidth="79%"
                                              :modelValue="form.alityRepair" :options="pipeSectionList" labelWidth="24%"
                                              @update:modelValue="(value) => handleModelValueUpdate('alityRepair', value)"
                                />
                            </div>
                        </div>
                        <div class="tieIn-content-form">
<!--                            <div class="tieIn-title">-->
<!--                                <div class="tieIn-title-name">结构性缺陷</div>-->
<!--                                <div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="平均值S" type="text" id="structAvgs" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.structAvgs" placeholder="请输入平均值S"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('structAvgs', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="最大值Smax" type="text" id="structsmax"  inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.structsmax" placeholder="请输入最大值Smax"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('structsmax', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="缺陷等级" type="text" id="structGrade" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.structGrade" placeholder="请输入缺陷等级"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('structGrade', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="缺陷密度" type="text" id="structDensity" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.structDensity" placeholder="请输入缺陷密度"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('structDensity', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="修复指数RI" type="text" id="structRepair" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.structRepair" placeholder="请输入修复指数RI"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('structRepair', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo1">-->
<!--                                        <TextareaField :modelValue="form.structEvaluate"  label="综合状况评价" labelWidth="40%"-->
<!--                                                       placeholder="请输入综合状况评价" textareaheight="12vh" id="structEvaluate"-->
<!--                                                       @update:modelValue="(value) => handleModelValueUpdate('structEvaluate', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="tieIn-title">-->
<!--                                <div class="tieIn-title-name">结构性缺陷</div>-->
<!--                                <div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="平均值Y" type="text" id="alityAvgy" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.alityAvgy" placeholder="请输入平均值Y"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('alityAvgy', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="最大值Ymax" type="text" id="alityymax" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.alityymax" placeholder="请输入最大值Ymax"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('alityymax', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="缺陷等级" type="text" id="alityGrade" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.alityGrade" placeholder="请输入缺陷等级"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('alityGrade', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="缺陷密度" type="text" id="alityDensity" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.alityDensity" placeholder="请输入缺陷密度"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('alityDensity', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo">-->
<!--                                        <InputField label="修复指数RI" type="text" id="alityRepair" inputDivWidth="60%"-->
<!--                                                    label-width="40%" :modelValue="form.alityRepair" placeholder="请输入修复指数RI"-->
<!--                                                    @update:modelValue="(value) => handleModelValueUpdate('alityRepair', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                    <div class="tieInInfo1">-->
<!--                                        <TextareaField :modelValue="form.alityEvaluate"  label="综合状况评价" labelWidth="40%"-->
<!--                                                       placeholder="请输入综合状况评价" textareaheight="12vh" id="alityEvaluate"-->
<!--                                                       @update:modelValue="(value) => handleModelValueUpdate('alityEvaluate', value)"-->
<!--                                        />-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </form>
                    <div class="tieIn-button">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField text="保存" primary @click="handleSubmit"/>
                </a-space>
            </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="视频">
                    <div>
                        <div>
                            <video controls v-if="form.videoUrl">
                                <source :src="form.videoUrl" type="video/mp4">
                                浏览器不支持视频播放。
                            </video>
                            <div v-else style="color: #adadad;">当前的管段信息缺陷视频。</div>
                        </div>
                        <div style="width: 100%;text-align: center;margin: 1rem 0;">
                            <Upload :list="fileList" @change="onUpload" :title="'上传视频'"/>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>

        </div>
    </div>
</template>

<script>
export default {
    name: "tieIn",
    props:{
        defect:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data() {
        return {
            pipeTypes:[{name:'污水',value:'污水'},{name:'雨水',value:'雨水'}],
            detDirections:[{name:'顺流',value:'顺流'},{name:'逆流',value:'逆流'}],
            form:{videoUrl: ''},activeTab: "1",fileList: [],
            pipeDefectList:[
                {name:'Ⅰ等级-无或有轻微缺陷，结构状况基本不受影响，但具有潜在变坏的可能',value:'Ⅰ'},{name:'Ⅱ等级-管段缺陷明显超过一级，具有变坏的趋势',value:'Ⅱ'},
                {name:'Ⅲ等级-管段缺陷严重，结构状况受到影响',value:'Ⅲ'},{name:'Ⅳ等级-管段存在重大缺陷，损坏严重或即将导致破坏',value:'Ⅳ'},
            ],
            repairIndexList:[
                {name:'Ⅰ等级-结构条件基本完好，不修复',value:'Ⅰ'},{name:'Ⅱ等级-结构在短期内不会发生破坏现象，但应做修复计划',value:'Ⅱ'},
                {name:'Ⅲ等级-结构在短期内可能会发生破坏，应尽快修复',value:'Ⅲ'},{name:'Ⅳ等级-结构已经发生或即将发生破坏，应立即修复',value:'Ⅳ'},
            ],
            functionDefectList:[
                {name:'Ⅰ等级-无或有轻微影响，管道运行基本不受影响',value:'Ⅰ'},{name:'Ⅱ等级-管道过流有一定的受阻，运行受影响不大',value:'Ⅱ'},
                {name:'Ⅲ等级-管道过流受阻比较严重，运行受到明显影响',value:'Ⅲ'}, {name:'Ⅳ等级-管道过流受阻很严重，即将或已经导致运行瘫痪',value:'Ⅳ'},
            ],
            pipeSectionList:[
                {name:'Ⅰ等级-没有明显需要处理的缺陷',value:'Ⅰ'},{name:'Ⅱ等级-没有立即进行处理的必要，但宜安排处理计划',value:'Ⅱ'},
                {name:'Ⅲ等级-根据基础数据进行全面的考虑，应尽快处理',value:'Ⅲ'},{name:'Ⅳ等级-输水功能受到严重影响，应立即进行处理',value:'Ⅳ'},
            ]
        }
    },
    mounted() {
        this.form = { ...this.$props.defect };
        this.form.videoUrl = this.form.videoUrl || '';
        this.fileList = this.form.videoUrl ? this.form.videoUrl.split(';') : [];
    },
    methods:{
        onUpload(val) {
            this.fileList = val || [];
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        cancel(){
            this.$emit( 'cancel',false)
        },
        handleSubmit(){
            console.log(" this.fileList:::", this.fileList)
            this.form.videoUrl = this.fileList.map(file => file.completePath).join(';');
            this.$emit( 'update',this.form)
            this.$emit( 'cancel',false)
        }
    }
}
</script>
<style scoped>
.tieIn{
    color: #fff;
}
.tieInInfo{
    display: flex;
    justify-content: space-between;
}
.tieInInfo1{
    margin: 0.5rem 0;
}
.tieInInfo{
    margin: 0.5rem 0;
}
.tieIn-button{
    display: flex;
    justify-content: center;
    margin: 1rem  0;
}
.tieIn-content-form{
    display: flex;
    justify-content:space-between;
}
.tieIn-title-name{
    color: #00d4ff;
    width: 48%;
}

.zoom-tip {
    z-index: 100;
    display: flex;
    margin-bottom: 0.5rem;
}
.zoom-tip > div{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem;
}
.zoom-tip{
    color: #adadad;
}

.detail-item {
    display: flex;
    margin-bottom: 0.5rem;
}

.label {
    margin-right: 0.5rem;
    font-weight: bold;
}

.value {
    color: #38a578;
}



::v-deep .ant-tabs-nav .ant-tabs-tab-active{
    color: #00fd95;
    text-shadow: 0 0 0.25px #00fd95;
}
::v-deep .ant-tabs-ink-bar{
    background: #00ff96;
}
::v-deep .ant-tabs-tab{
    color:#fff;
}

.tabsTieIn ::v-deep .ant-tabs-nav .ant-tabs-tab-active{
    color: #00e0e2;
    text-shadow: 0 0 0.25px #00e0e2;
}
.tabsTieIn  ::v-deep .ant-tabs-ink-bar{
    background: #00e0e2;
}


video {
    width: 100%;
    height: 50vh;
}
</style>